var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_menu)?_c('div',[_c('nav',[_c('Nav'),(_vm.isBelowMd)?_c('NavMobile'):_vm._e()],1),_c('notifications'),_c('PwaUpdater'),_c('PwaDownload'),_c('ImportHorseMicroship',{ref:"import_horse_microship"}),_c('LicenceReminder')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }